<template>
  <div class="c-avatar-list">
    <ul class="listless inline" v-if="!isDemo">
      <li class="counter" v-if="total > 5 && showCount">
        <button @click="toggleList">{{ totalString }}</button>
      </li>
      <li v-for="user in users" :key="user.id">
        <router-link :to="{ path: `/user/${user.id}` }"
          ><user-avatar :user="user"
        /></router-link>
      </li>
    </ul>
    <ul class="listless inline" v-else>
      <li class="counter" v-if="total > 5 && showCount">
        <button @click="toggleList">{{ totalString }}</button>
      </li>
      <li v-for="i in 5" :key="i">
        <router-link :to="{ path: `/user/${currentUser.id}` }"
          ><user-avatar :user="currentUser"
        /></router-link>
      </li>
    </ul>
    <modal v-if="showAllUsers" show-close-button @close="toggleList">
      <h2 slot="header">Interested users</h2>

      <ul class="listless user-list">
        <li v-for="i in total" :key="i" class="m-bottom-10">
          <router-link
            :to="{ path: `/user/${currentUser.id}` }"
            class="flex-row td-none"
            ><user-avatar :user="currentUser" class="m-right-10" />
            <span>{{ currentUser.name }}<br /><span class="text-mid-grey">{{currentUser.position}}</span></span></router-link
          >
        </li>
      </ul>
    </modal>
  </div>
</template>

<script>
/**
 * Avatar list
 * Shows avatars based on passed user ID's
 * Ideally, needs to show current user first if they exist in array
 * Needs a way of linking up to an event so it can be updated in real time
 * Also, needs to only show 5 users then calculate the number of people left
 * Up to a maximum of 999 because space
 */
import UserAvatar from "@/components/UserAvatar";
export default {
  data() {
    return {
      showAllUsers: false,
    };
  },
  props: {
    showCount: {
      type: Boolean,
      default: true,
    },
    users: {
      type: Array,
      default: () => [],
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UserAvatar,
  },
  computed: {
    total() {
      return this.isDemo ? 20 : this.users.length;
    },
    currentUser() {
      return this.$store.state.auth.currentUser;
    },
    totalString() {
      const difference = this.total - 5;
      return difference < 999 ? `+${difference}` : "+999";
    },
  },
  methods: {
    toggleList() {
      this.showAllUsers = !this.showAllUsers;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-avatar-list {
  > ul {
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    margin-left: -4px;
    li {
      background: $colour-nhs-pale-grey;
      border: 4px solid #f0f5fb;
      border-radius: 100%;
      height: 40px;
      margin-right: -8px;
      position: relative;
      transition: all ease-in-out 0.2s;
      width: 40px;

      &:hover {
        margin-top: -5px;
      }

      &.counter {
        background: transparent;
        &:hover {
          margin-top: 0;
        }
        button {
          align-items: center;
          background: transparent;
          border-color: $colour-nhs-dark-grey;
          border-radius: 100%;
          border-width: 1px;
          color: $colour-nhs-dark-grey;
          cursor: pointer;
          display: inline-flex;
          font-size: 0.75rem;
          height: 36px;
          margin-left: 10px;
          justify-content: center;
          width: 36px;

          &:hover {
            border-color: $colour-nhs-core-blue;
            color: $colour-nhs-core-blue;
          }
        }
      }
    }
  }

  .user-list {
    /deep/ .c-avatar {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
